import { Box, SelectChangeEvent } from '@mui/material';
import { useCallback, useContext, useEffect, useState } from 'react';

import { SelectInput } from '@/components/common/select_input/SelectInput';
import { PartnerIntakeContext } from '@/Contexts/PartnerIntakeContext';

function LowestGradeInput() {
  const [lowestGradeSelection, setLowestGradeSelection] = useState<number | null>(null);
  const { partnerInfo, intakeLabels, updatePartnerInfo, showErrors } =
    useContext(PartnerIntakeContext);

  const handleLowestGradeChange = useCallback(
    (e: SelectChangeEvent) => {
      e.preventDefault();
      e.stopPropagation();

      const updatedValue = (e.target as HTMLInputElement).value;

      if (updatePartnerInfo && partnerInfo) {
        updatePartnerInfo({
          ...partnerInfo,
          lowestGrade: Number(updatedValue),
        });
      }
    },
    [updatePartnerInfo, partnerInfo]
  );

  useEffect(() => {
    if (partnerInfo?.lowestGrade != lowestGradeSelection) {
      const updatedValue =
        partnerInfo?.lowestGrade !== null && partnerInfo?.lowestGrade !== undefined
          ? partnerInfo.lowestGrade
          : null;
      setLowestGradeSelection(updatedValue);
    }
  }, [lowestGradeSelection, partnerInfo?.lowestGrade, setLowestGradeSelection]);

  return (
    <Box flexGrow={1}>
      <SelectInput
        label={intakeLabels?.lowestGrade ?? ''}
        id='lowest-grade-select'
        value={
          lowestGradeSelection !== null && lowestGradeSelection !== undefined
            ? lowestGradeSelection.toString()
            : ''
        }
        required
        hasError={showErrors && lowestGradeSelection == null}
        onChange={handleLowestGradeChange}
        selectOptions={[
          { value: '-1', label: 'Pre-K' },
          { value: '0', label: 'Kindergarten' },
          { value: '1', label: '1st' },
          { value: '2', label: '2nd' },
          { value: '3', label: '3rd' },
          { value: '4', label: '4th' },
          { value: '5', label: '5th' },
          { value: '6', label: '6th' },
          { value: '7', label: '7th' },
          { value: '8', label: '8th' },
          { value: '9', label: '9th' },
          { value: '10', label: '10th' },
          { value: '11', label: '11th' },
          { value: '12', label: '12th' },
        ]}
      />
    </Box>
  );
}

export default LowestGradeInput;
